import styled, { css } from "styled-components";
import { zIndex } from "../theme";
export const StyledSection = styled.div<{
  align?: "center" | "flex-start" | "flex-end";
  flex?: number;
}>`
  display: flex;
  flex: ${({ flex }) => flex || 1};
  align-items: center;
  ${({ align }) =>
    align &&
    css`
      justify-content: ${align};
    `}
`;

export const StyledMobilePanel = styled.nav`
  display: flex;
  background: var(--sinch-ref-color-main-snow-100);
  z-index: ${zIndex.overContentMenu};
  padding: 0 12px;
  grid-column: span 2;
  grid-row: 1;
`;

export const StyledPanelWrapper = styled.div`
  border-bottom: 1px solid var(--sinch-sys-color-border-default);
  display: flex;
  flex-direction: row;
  flex: 1;
`;
